const STORAGE_KEY = 'superoti.kitchen.device'

export type KitchenDeviceBinding = {
  deviceId: string
  deviceUid: string
  deviceName: string
  kitchenId: string
  kitchenCode?: string
  kitchenName: string
  deviceType: 'kitchen_tablet'
  activatedAt: string
}

export function getKitchenDevice(): KitchenDeviceBinding | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    return JSON.parse(raw) as KitchenDeviceBinding
  } catch {
    return null
  }
}

export function setKitchenDevice(binding: KitchenDeviceBinding): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(binding))
}

export function clearKitchenDevice(): void {
  localStorage.removeItem(STORAGE_KEY)
}

export function hasKitchenDevice(): boolean {
  return getKitchenDevice() !== null
}
